import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Select,
  Upload,
  Button,
  Row,
  Col,
  Tag,
  message,
  Card,
  Modal,
  DatePicker,
} from "antd";
import {
  UploadOutlined,
  PlusOutlined,
  DeleteOutlined,
} from "@ant-design/icons";

import { ArrowUpFromLine, Trash2, Users } from "lucide-react";
import { useLocation, useNavigate, useParams } from "react-router";
import CheckBigImage from "../../assets/images/newimages/check-big-Image.svg";
import DownloadImage from "../../assets/images/newimages/download-line.svg";
import CopylinkImage from "../../assets/images/newimages/file-copy-line.svg";
import { Severty, ShowToast } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";
import moment from "moment";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const { Option } = Select;

const LaunchFollowUpSurveyForm = () => {
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [surveyDetails, setSurveyDetails] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const { request } = useRequest();
  const [surveyList, setSurveyList] = useState([]);
  const [formAction, setFormAction] = useState(null);
  const [surveyId, setSurveyId] = useState(null);
  const [surveyLink, setSurveyLink] = useState("");
  const [leaderSurveyLink, setLeaderSurveyLink] = useState("");
  const [value, setValue] = useState("");
  const [surveys, setSurveys] = useState([]);
  const [sId, setSId] = useState(null);

  useEffect(() => {
    form.setFieldsValue({
      draft: `<p><span style="color: rgb(33, 33, 33); background-color: transparent;">Greetings from TEAM INTELLIGENCE HUB</span></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">&nbsp;</span></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">We are reaching out as part of a team development program.</span></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">&nbsp;</span></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">We are seeking your support to complete a team survey aimed at gaining insights into your team’s dynamics. Your input is important in helping us better&nbsp;understand&nbsp;the dynamics and individual challenges of the team.</span></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">&nbsp;</span></p><p>{{LINK}}</p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">&nbsp;</span></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">The survey should take 10 minutes at most. Your responses will remain anonymous&nbsp;and will contribute to&nbsp;further strengthen and ensure your team’s continued effectiveness and success.&nbsp;</span></p><p><br></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">Please complete the survey by {{DEADLINE}}</span></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">&nbsp;</span></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">Thank you for your participation in this effort to&nbsp;enhance&nbsp;your team’s performance.</span></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">&nbsp;&nbsp;</span></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">TEAM INTELLIGENCE HUB</span></p><p><br></p>`,
      draftMember: `<p><span style="color: rgb(33, 33, 33); background-color: transparent;">Greetings from TEAM INTELLIGENCE HUB</span></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">&nbsp;</span></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">We are reaching out as part of a team development program.</span></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">&nbsp;</span></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">We are seeking your support to complete a team survey aimed at gaining insights into your team’s dynamics. Your input is important in helping us better&nbsp;understand&nbsp;the dynamics and individual challenges of the team.</span></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">&nbsp;</span></p><p>{{LINK}}</p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">&nbsp;</span></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">The survey should take 10 minutes at most. Your responses will remain anonymous&nbsp;and will contribute to&nbsp;further strengthen and ensure your team’s continued effectiveness and success.&nbsp;</span></p><p><br></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">Please complete the survey by {{DEADLINE}}</span></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">&nbsp;</span></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">Thank you for your participation in this effort to&nbsp;enhance&nbsp;your team’s performance.</span></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">&nbsp;&nbsp;</span></p><p><span style="color: rgb(33, 33, 33); background-color: transparent;">TEAM INTELLIGENCE HUB</span></p><p><br></p>`,
    });
  }, [value]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const members = params.get("members");
    const id = params.get("surveyId");

    if (members) {
      form.setFieldsValue({
        teamSize: Number(members),
      });
    }
    if (id) {
      setSurveyId(id);
      fetchSurveyData(id);
    }
  }, [location]);

  const fetchSurveyData = async (id) => {
    setLoading(true);
    try {
      request({
        url: `/admin/mf/survey/getSurvey/${id}`,
        method: "GET",
        onSuccess: (data) => {
          const surveyData = data;
          if (surveyData.deadline) {
            surveyData.targetDeadline = moment(surveyData.deadline);
          }
          console.log(surveyData, "surveyData");
          const requesterId = surveyData?.requesterId;
          const leaders = surveyData?.leaders || [];

          let followUpSurvey = null;
          if (leaders.some((leader) => leader._id === requesterId)) {
            followUpSurvey = "TPSForLeaders";
          }

          const mappedData = {
            ...surveyData,
            teamLeaderName: surveyData.leader?.name || "",
            teamLeaderEmail: surveyData.leader?.email || "",
            draftMember: surveyData.emailTemplates?.memberTemplate || "",
            draft: surveyData.emailTemplates?.leaderTemplate || "",
            members:
              surveyData.members?.map((m) => ({
                name: m.name,
                email: m.email,
              })) || [],
            survey: followUpSurvey,
          };
          form.setFieldsValue(mappedData);
        },
        onError: (error) => {
          ShowToast(
            error.response?.data?.message || "Failed to Fetch Survey",
            Severty.ERROR
          );
          setLoading(false);
        },
      });
    } catch (err) {
      ShowToast(
        err.response?.data?.message || "Failed to load survey data",
        Severty.ERROR
      );
    } 
  };

  useEffect(() => {
    loadSurveyList();
  }, [id]);

  const loadSurveyList = async () => {
    try {
      setLoading(true);
      request({
        url: `/admin/mf/survey/list?surveyType=Leader`,
        method: "GET",
        onSuccess: (data) => {
          setSurveyList(data || []);
          setLoading(false);
        },
        onError: (error) => {
          ShowToast(
            error.response?.data?.message || "Failed to load surveys",
            Severty.ERROR
          );
          setLoading(false);
        },
      });
    } catch {
      message.error("Failed to load surveys");
      setLoading(false);
    }
  };

  const onFinish = async (values) => {
    console.log("Form Values:", values);
    console.log("Action:", formAction);
    try {
      setLoading(true);

      const payload = {
        surveyType: "FollowUpLeader",
        baseSurveyId: sId,
        teamName: values.teamName,
        leader: {
          name: values.teamLeaderName,
          email: values.teamLeaderEmail,
        },
        language: values.language,
        members: values.members || [],
        paymentType: "Credit",
        deadline: values.targetDeadline,
        emailTemplate: values.draft,
        emailTemplates: {
          memberTemplate: values.draftMember,
          leaderTemplate: values.draft,
        },
        status: formAction === "launch" ? "Open" : "Review",
      };

      console.log("Submitting payload:", surveyId, payload);
      const config = {
        url: surveyId
          ? `/admin/mf/survey/update/${surveyId}`
          : "/admin/mf/survey/followup-leader",
        method: surveyId ? "PUT" : "POST",
        data: payload,
      };

      console.log("Request Config:", config);
      request({
        url: config.url,
        data: payload,
        method: config.method,
        onSuccess: (data) => {
          console.log(data, "data here");
          if (formAction === "review") {
            ShowToast("Survey details saved for review", Severty.SUCCESS);
            navigate("/followupforleaderform");
          } else if (formAction === "launch") {
            ShowToast(
              data?.message || "Survey created successfully!",
              Severty.SUCCESS
            );
            setIsModalVisible(true);
            // navigate("/followupforleaderform");
          }
          setSurveyLink(data?.survey?.surveyLink || "");
          setLeaderSurveyLink(data?.survey?.surveyLeaderLink || "");
          setIsModalVisible(formAction === "launch");
          setLoading(false);
        },
        onError: (error) => {
          console.log(error, "error onErorr");
          ShowToast(
            error.response?.data?.message || "Failed to Create Survey",
            Severty.ERROR
          );
          setLoading(false);
        },
      });
    } catch (err) {
      console.error(err, "here error");
      message.error(err.response?.data?.message || "Survey creation failed");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchSurveys();
  }, []);

  const fetchSurveys = async () => {
    try {
      request({
        url: `/mf/survey/list?surveyType=Leader`,
        method: "GET",
        onSuccess: (data) => {
          setSurveys(data || []);
        },
        onError: (error) => {
          ShowToast(
            error.response?.data?.message || "Failed to Fetch Survey",
            Severty.ERROR
          );
        },
      });
    } catch (err) {
      ShowToast(
        err.response?.data?.message || "Failed to load surveys",
        Severty.ERROR
      );
    }
  };

  const handleSurveySelect = (id) => {
    const survey = surveys?.find((sr) => sr?._id === id);
    setSId(id);
    form.setFieldsValue({
      ...survey,
      teamLeaderName: survey.leader?.name || "",
      teamLeaderEmail: survey.leader?.email || "",
      targetDeadline: moment(survey?.deadline),
      draftMember: survey.emailTemplates?.memberTemplate || "",
      draft: survey.emailTemplates?.leaderTemplate || "",
      // deadline: moment(survey?.deadline),
    });
  };

  const handleModalCloseAndNavigate = () => {
    setIsModalVisible(false);
    navigate("/followupforleaderform");
    form.resetFields();
  };

  const handleCopyLink = async () => {
    if (!surveyLink) {
      message.error("No survey link available!");
      return;
    }
    try {
      await navigator.clipboard.writeText(surveyLink);
      message.success("Survey link copied!");
    } catch (err) {
      message.error("Failed to copy link.");
    }
  };

  const handleDownloadLink = () => {
    if (!surveyLink) {
      message.error("No survey link available!");
      return;
    }
    const content = `Team Survey Link: ${surveyLink}\n\nLeader Survey Link: ${leaderSurveyLink}`;

    const element = document.createElement("a");
    const file = new Blob([content], { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    element.download = "tps-survey-link.txt";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };
  return (
    <>
      <div className="purchase-survey-cards-main">
        <Card className="purchase-survey-cards">
          <div className="purchase-survey-cards-header-main mb-3">
            <h4 className="purchase-survey-cards-header">
              <Users />
              Follow Up TPS for Leaders Survey
            </h4>
          </div>
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            initialValues={{ tags: ["emailDisplay"] }}
          >
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  label="Select the TPS for Leaders Survey for which there needs to be a follow Up now"
                  name="survey"
                  rules={[
                    { required: true, message: "Please select a survey" },
                  ]}
                >
                  <Select
                    placeholder="Select survey"
                    onChange={handleSurveySelect}
                  >
                    {surveys?.map((item) => {
                      return <Option key={item?._id}>{item?.teamName}</Option>;
                    })}
                  </Select>
                </Form.Item>
              </Col>

              <Col span={24} md={12}>
                <Form.Item
                  label="Language for Survey and report"
                  name="language"
                  rules={[{ required: true, message: "Select language" }]}
                >
                  <Select placeholder="Language for Survey and report">
                    <Option value="en">English</Option>
                    <Option value="fr">French</Option>
                    <Option value="de">German</Option>
                  </Select>
                </Form.Item>
              </Col>

              <Col span={24} md={12}>
                <Form.Item
                  label="Team Name"
                  name="teamName"
                  rules={[{ required: true, message: "Enter team name" }]}
                >
                  <Input
                    placeholder="Enter team name"
                    disabled={surveyDetails?.hasResponse}
                  />
                </Form.Item>
              </Col>

              <Col span={24} md={12}>
                <Form.Item
                  label="Team Leader Name"
                  name="teamLeaderName"
                  rules={[{ required: true }]}
                >
                  <Input placeholder="Enter Team Leader Name" />
                </Form.Item>
              </Col>
              <Col span={24} md={12}>
                <Form.Item
                  label="Team Leader Email"
                  name="teamLeaderEmail"
                  rules={[{ required: true }]}
                >
                  <Input placeholder="Enter Team Leader email" />
                </Form.Item>
              </Col>
            </Row>

            <Form.List name="members">
              {(fields, { add, remove }) => (
                <>
                  <div className="add-team-men-mbers-main">
                    <h5>Team Members Email</h5>
                    <Row
                      gutter={[12, 12]}
                      align="middle"
                      style={{ marginBottom: 16 }}
                    >
                      <Col>
                        <Form.Item name="upload" noStyle>
                          <Upload
                            beforeUpload={() => false}
                            showUploadList={false}
                          >
                            <Button icon={<ArrowUpFromLine />}>
                              Upload Excel
                            </Button>
                          </Upload>
                        </Form.Item>
                      </Col>
                      <Col>
                        <Button
                          icon={<PlusOutlined />}
                          onClick={() => add()}
                          type="primary"
                        >
                          Add Member
                        </Button>
                      </Col>
                    </Row>
                  </div>

                  {fields.map((field) => (
                    <Row
                      key={field.key}
                      gutter={[12, 12]}
                      align="middle"
                      style={{ marginBottom: 12 }}
                    >
                      {/* <Col flex="auto">
                        <Form.Item
                          {...field}
                          name={[field.name, "name"]}
                          noStyle
                          rules={[
                            { required: true, message: "Enter name" },
                            { type: "name", message: "Invalid name" },
                          ]}
                        >
                          <Input placeholder="Member name" />
                        </Form.Item>
                      </Col> */}
                      <Col flex="auto">
                        <Form.Item
                          {...field}
                          name={[field.name, "email"]}
                          noStyle
                          rules={[
                            { required: true, message: "Enter email" },
                            { type: "email", message: "Invalid email" },
                          ]}
                        >
                          <Input placeholder="Member email" />
                        </Form.Item>
                      </Col>
                      <Col>
                        <Button
                          type="text"
                          onClick={() => remove(field.name)}
                          className="delete-button-binn"
                        >
                          <Trash2 />
                        </Button>
                      </Col>
                    </Row>
                  ))}
                </>
              )}
            </Form.List>

            <Form.Item name="targetDeadline" label="Survey Deadline">
              <DatePicker
                style={{ width: "100%" }}
                placeholder="mm/dd/yyyy"
                disabledDate={(current) => {
                  // Disable dates before today
                  return current && current < moment().startOf("day");
                }}
              />
            </Form.Item>

            {/* <Form.Item
              name="draft"
              label="Email Template (Team Leader)"
              rules={[{ required: true }]}
            >
              <CKEditor
                editor={ClassicEditor}
                data={form.getFieldValue("draft") || ""}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  form.setFieldsValue({ draft: data });
                }}
              />
            </Form.Item>

            <Form.Item
              name="draftMember"
              label="Email Template (Team Members)"
              rules={[{ required: true }]}
            >
              <CKEditor
                editor={ClassicEditor}
                data={form.getFieldValue("draftMember") || ""}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  form.setFieldsValue({ draftMember: data });
                }}
              />
            </Form.Item> */}

            <Form.Item name="draft" label="Email Template (Team Leader)">
              <ReactQuill
                theme="snow"
                value={value}
                onChange={setValue}
                placeholder="Enter Email Template..."
                style={{ height: "250px", marginBottom: "40px" }}
              />
            </Form.Item>

            <Form.Item name="draftMember" label="Email Template (Team Members)">
              <ReactQuill
                theme="snow"
                value={value}
                onChange={setValue}
                placeholder="Enter Email Template..."
                style={{ height: "250px", marginBottom: "40px" }}
              />
            </Form.Item>

            <div className="modal-footer-main">
              <Button disabled={loading} type="link" onClick={() => navigate(-1)}>
                Back
              </Button>
              {/* <Button
                type="default"
                htmlType="submit"
                onClick={() => setFormAction("review")}
                loading={loading && formAction === "review"}
              >
                Review
              </Button> */}
              <Button
                type="primary"
                htmlType="submit"
                onClick={() => setFormAction("launch")}
                loading={loading}
              >
                Launch TPS Survey
              </Button>
            </div>
          </Form>
        </Card>

        <Modal
          open={isModalVisible}
          // onCancel={() => {
          //   setIsModalVisible(false)
          //   navigate("/tq-team-servey");
          // }}

          onCancel={handleModalCloseAndNavigate}
          footer={null}
          centered
          closable={false}
          width={540}
          bodyStyle={{ textAlign: "center", padding: 24 }}
        >
          <div className="members-modal-main members-modal-main-check">
            <div className="question-mark-image">
              <img src={CheckBigImage} alt="Question Mark" />
            </div>
            <h4>Invitation Sent Successfully!</h4>
            <h6>
              Your TPS survey has been sent to all team members via email.{" "}
              <br />
              You can also copy the Survey link below.
            </h6>
            <div className="cpoy-link-button" onClick={handleCopyLink}>
              <img src={CopylinkImage} alt="copy" /> Copy Link
            </div>
            <div className="modal-footer-main">
              <Button onClick={handleModalCloseAndNavigate} type="link">
                Cancel
              </Button>
              <Button type="primary" onClick={handleDownloadLink}>
                <img src={DownloadImage} alt="download" /> Download Link
              </Button>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default LaunchFollowUpSurveyForm;

const industries = [
  "Agriculture, Forestry, Mining and Fishing",
  "Construction and Real Estate",
  "Consulting Services",
  "Education and Research",
  "Finance and Insurance",
  "Healthcare and Life Sciences",
  "Information Technology and Telecommunications",
  "Manufacturing and Industrial Production",
  "Public Sector and Nonprofit",
  "Retail, Wholesale, and Consumer Goods",
  "Transportation, Logistics, and Travel",
  "Other",
];

const roles = [
  "Customer Service / Support",
  "Engineering / Technical",
  "Executive / General Management",
  "Finance / Accounting",
  "Human Resources (HR)",
  "Information Technology (IT) / Systems",
  "Legal / Compliance",
  "Marketing / Communications",
  "Operations / Supply Chain / Logistics",
  "Product Management",
  "Quality / Health & Safety",
  "Research & Development (R&D)",
  "Sales / Business Development",
  "Strategy / Corporate Development",
  "Other",
];
const getStatusTag = (status) => {
  switch (status) {
    case "Open":
      return <span className="status-tag open">Open</span>;
    case "Closed":
      return <span className="status-tag closed">Closed</span>;
    case "PastDeadline":
      return <span className="status-tag past-deadline">Past Deadline</span>;
    default:
      return <span className="status-tag unknown">Unknown</span>;
  }
};
